var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5"},[_c('h2',[_vm._v(" "+_vm._s(_vm.text)+" "),_c('CIcon',{staticClass:"text-danger mb-2",attrs:{"width":"30","name":"cil-ban"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }